import React from 'react';
import toast from 'react-hot-toast';
import styles from '@/components/ui/Toast/Toast.module.css';
import { Toast } from '@/components/ui';
import { ToastContext } from './ToastContext';

const ToastProvider: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  const showToast = (
    type: 'success' | 'info' | 'warn' | 'error',
    title: string,
    duration?: number
  ) => {
    toast.custom(<Toast type={type} title={title} />, {
      duration: duration ?? 3000,
      position: 'bottom-center',
      className: styles.toast
    });
  };

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
    </ToastContext.Provider>
  );
};

export default ToastProvider;
